<template>
  <!-- modal -->
  <Popper
    v-bind="$attrs"
    :title="$t('ui.generals.attach_link')"
    @shown="getSelection(), focusInput()"
    @close="reset"
  >
    <!-- trigger -->
    <template #popper-trigger>
      <AppIcon :title="$t('ui.tooltips.create_link')" icon="far fa-link" />
    </template>
    <!-- content -->
    <template #popper-content="{ closePopper }">
      <div
        class="link-embed__form"
        @keypress.enter="sendEmbed(), closePopper()"
        @keydown.esc="closePopper"
        data-option="embed-link"
      >
        <!-- LINK NAME -->
        <label for="add-link">
          {{ $t('ui.generals.text') }}
        </label>
        <AppInput
          class="link-embed__selected-text"
          v-model="linkName"
          :disabled="disabledNameInput"
        />
        <!-- LINK -->
        <label for="add-link">
          {{ $t('ui.generals.paste_link') }}
        </label>
        <AppInput class="link-embed__link" id="add-link" v-model="linkURL" />
        <!-- SAVE BUTTON -->
        <AppButton :disabled="!linkURL" @click="linkURL && sendEmbed(), closePopper()">
          {{ $t('ui.buttons.save') }}
        </AppButton>
      </div>
    </template>
  </Popper>
</template>

<script>
// Utilities
import { EventBus } from '@/main'
// Components
import AppIcon from 'Ui/AppIcon'
import Popper from 'Modules/Popper'
import AppInput from 'Ui/AppInput'
import AppButton from 'Ui/AppButton'

export default {
  name: 'CommentBoxLinkEmbed',

  components: {
    Popper,
    AppIcon,
    AppInput,
    AppButton,
  },

  data() {
    return {
      linkName: '',
      linkURL: '',
      disabledNameInput: false,
    }
  },

  methods: {
    reset() {
      this.linkName = ''
      this.linkURL = ''
      this.disabledNameInput = false
    },

    sendEmbed() {
      const embed = {
        embed: this.embedLink,
        name: this.linkName,
      }

      this.$emit('embeded-link', embed)
      this.reset()
    },

    getSelection() {
      const textarea = this.$el.closest('.comment-box__field').querySelector('.app-textarea')
      const selectionStart = textarea.selectionStart
      const selectionEnd = textarea.selectionEnd
      // no selection just focused ⤵
      if (selectionStart === selectionEnd) return
      this.disabledNameInput = true
      this.linkName = textarea.value.substring(selectionStart, selectionEnd)
    },

    async focusInput() {
      await this.$nextTick()
      // focus the first available input
      const linkInput = document.querySelector('.link-embed__form .app-input:not(:disabled)')
      linkInput.focus()
    },
  },

  computed: {
    embedLink() {
      let embed
      if (this.linkName && this.linkURL) embed = `[${this.linkName}](${this.formatedLink})`
      if (!this.linkName) embed = this.formatedLink

      return embed
    },

    formatedLink() {
      let formatedLink
      const hasProtocol = this.linkURL.search(/^http[s]?:\/\//) != -1
      if (!hasProtocol) formatedLink = `https://${this.linkURL}`
      if (hasProtocol) formatedLink = this.linkURL
      return formatedLink
    },
  },

  async mounted() {
    await this.$nextTick()
    const openFunc = this.$children[0].togglePopper
    EventBus.$on('open-box', openFunc)
  },

  destroyed() {
    EventBus.$off('open-box', this.$children[0].togglePopper)
  },
}
</script>

<style scoped>
.link-embed__form {
  padding-bottom: 6px;
}

.link-embed__heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid var(--c-secondary-400);
}

.link-embed__heading p {
  margin: 0;
}

.link-embed__heading .app-button--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 50px;
  background-color: transparent;
}

.link-embed__heading .app-button--icon:hover {
  background-color: var(--c-secondary-300);
}

.link-embed__heading >>> .app-button--icon .app-icon {
  font-size: 14px;
}

.link-embed__form label {
  display: inline-block;
  font-size: 12px;
  line-height: 16px;
  color: var(--c-primary);
}

.link-embed__selected-text ~ label {
  margin-top: 10px;
}

.link-embed__form .app-input-field {
  margin-top: 5px;
}

.link-embed__form >>> .app-input-field .app-input {
  color: var(--c-secondary);
  height: 36px;
}

.link-embed__form .app-button {
  font-size: 12px;
  width: auto;
  min-height: 32px;
  margin-top: 10px;
}

.app-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 20px;
  padding: 6px;
  width: 25px;
  height: 25px;
  border-radius: 3px;
  cursor: pointer;
}

.app-icon:hover {
  background-color: var(--c-secondary-400);
}
</style>
